module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av667-1b63242821dab728a10ec74a89b74e7f.jpg";